import { OUTBOUND_DATE, OUTBOUND, INBOUND } from 'constants/booking';
import moment from 'moment';

export const getMinDateBookingPath = (dateToChange, outboundDate, isReturnJourney) => {
  if (isReturnJourney) {
    return dateToChange === OUTBOUND_DATE ? moment().subtract(1, 'days') : moment.max(moment().subtract(1, 'days'), moment(outboundDate));
  }

  return moment().subtract(1, 'days');
};

export const getMinDateExchange = (
  dateToChange,
  outboundDate,
  isReturnJourney,
  subscriptionStart,
  direction,
  passengerOppositeJourney,
  hasSubscriptionFare,
  isExchangingSingleLegOfSNCBSummated,
  inboundDate
) => {
  const isExchangingBothWays = isReturnJourney;

  if (isExchangingSingleLegOfSNCBSummated) {
    return direction === OUTBOUND ? moment(outboundDate) : moment(inboundDate);
  }

  if (direction === INBOUND && !outboundDate && passengerOppositeJourney) {
    return moment(passengerOppositeJourney?.timing?.date);
  }

  if (isExchangingBothWays) {
    const outboundDateToUse =
      subscriptionStart && hasSubscriptionFare ? moment.max(moment(outboundDate), moment(subscriptionStart)) : outboundDate;
    return getMinDateBookingPath(dateToChange, outboundDateToUse, isReturnJourney);
  }

  return subscriptionStart && hasSubscriptionFare
    ? moment.max(moment().subtract(1, 'days'), moment(subscriptionStart))
    : moment().subtract(1, 'days');
};

export const getMaxDate = (
  dateToChange,
  isExchange,
  inboundDate,
  subscriptionEnd,
  direction,
  passengerOppositeJourney,
  hasSubscriptionFare,
  isExchangingSingleLegOfSNCBSummated,
  outboundDate
) => {
  if (isExchangingSingleLegOfSNCBSummated) {
    return direction === OUTBOUND ? moment(outboundDate).add(1, 'days') : moment(inboundDate).add(1, 'days');
  }

  if (isExchange && direction === OUTBOUND && !inboundDate && passengerOppositeJourney) {
    return moment(passengerOppositeJourney?.timing?.date).add(1, 'days');
  }

  if (dateToChange !== OUTBOUND_DATE || !isExchange) {
    return subscriptionEnd && hasSubscriptionFare ? moment(subscriptionEnd) : null;
  }

  if (!inboundDate) {
    return subscriptionEnd && hasSubscriptionFare ? moment(subscriptionEnd) : null;
  }

  return subscriptionEnd && hasSubscriptionFare
    ? moment.min(moment(inboundDate).add(1, 'days'), moment(subscriptionEnd))
    : moment(inboundDate).add(1, 'days');
};

export const getProductsFromItemRefs = ({ segments = [], selectedItemRefs = [] }) =>
  segments.reduce((acc, { products = [] }) => [...acc, ...products.filter(({ itemRef }) => selectedItemRefs.includes(itemRef))], []);
